// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__22iF8","header":"ClearentDisclaimer_header__NmePq","inner":"ClearentDisclaimer_inner__14JK4"};